import {useSelector} from '../../../../store.js'
import {
  modalFormSelector,
  updateModalForm,
} from './transferListFilterModalFunctions.js'
import TextInput from '../../../../common/components/TextInput.js'

export default function MiscFilterPanel() {
  const form = useSelector(modalFormSelector)

  return (
    <div className="wrap--modal-filters wrap--modal-filters-misc">
      <div className="wrap__modal-subheader margin-bottom-25">
        <h4 className="fs-01 uppercase margin-top-0 margin-bottom-0 flex--justify-col">
          <strong>Misc</strong>
        </h4>
      </div>
      <div className="margin-top-10 margin-bottom-30">
        <div className="fs-00">
          <strong>Free Text Search</strong>
        </div>
        <div className="flex margin-top-3">
          <div className="flex w-50 margin-right-15">
            <TextInput
              id="search"
              value={form.search}
              onChange={(search) => updateModalForm({search})}
            />
          </div>
          <em className="fs-n0 lh-md op-50 flex--justify-col">
            Filter by any transfer-related text string.
          </em>
        </div>
      </div>
    </div>
  )
}
